import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { roleService } from '../../services/role.service';

const Roles = () => {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRoles();
  }, []);

  const fetchRoles = async () => {
    try {
      const data = await roleService.getAllRoles();
      setRoles(data.roles || []);
    } catch (error) {
      toast.error('Failed to fetch roles');
    } finally {
      setLoading(false);
    }
  };

  const renderPermissions = (permissions) => {
    if (!permissions || !Array.isArray(permissions)) {
      return <span className="text-gray-400">No permissions</span>;
    }

    return permissions.map((perm, idx) => {
      // Handle if perm is an object with resource and actions
      if (typeof perm === 'object' && perm !== null) {
        const resource = perm.resource || 'unknown';
        const actions = Array.isArray(perm.actions) ? perm.actions.join(', ') : 'none';
        return (
          <span key={idx} className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded mr-1 mb-1 inline-block">
            {resource}: {actions}
          </span>
        );
      }
      // Handle if perm is a string
      return (
        <span key={idx} className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded mr-1 mb-1 inline-block">
          {String(perm)}
        </span>
      );
    });
  };

  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-6">Roles & Permissions</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {loading ? (
          <div className="col-span-3 p-8 text-center">Loading...</div>
        ) : roles.length === 0 ? (
          <div className="col-span-3 p-8 text-center text-gray-500">No roles found</div>
        ) : (
          roles.map((role) => (
            <div key={role._id} className="bg-white rounded-lg shadow p-6">
              <h3 className="text-xl font-bold mb-2">{role.displayName || role.name}</h3>
              <p className="text-sm text-gray-500 mb-4">System Name: {role.name}</p>
              
              <div className="space-y-2">
                <h4 className="font-semibold text-sm text-gray-700">Permissions:</h4>
                <div className="flex flex-wrap gap-1">
                  {renderPermissions(role.permissions)}
                </div>
              </div>

              {role.description && (
                <p className="text-sm text-gray-600 mt-4">{role.description}</p>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Roles;